
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import { Filter, Ordering, OrderType } from "@/models/ListRequest";
import vPagination from "@/components/vPagination.vue";
import TableHeader from "@/models/TableHeader";
import { mapState } from "vuex";
import vToggleSwitch from "@/components/vToggleSwitch.vue";
import vToggleSwitchSelfHandled from "@/components/vToggleSwitchSelfHandled.vue";
import vPreLoader from "@/components/vPreLoader.vue";
import vImageWithTooltip from "@/components/vImageWithTooltip.vue";

@Component({
  components: {
    vPagination,
    vToggleSwitch,
    vImageWithTooltip,
    vToggleSwitchSelfHandled,
    vPreLoader,
  },
  computed: {
    ...mapState({
      localizationState: (state: any) => state.LocalizationModule,
    }),
  },
})
export default class vTable extends Vue {
  page = 1;
  filters: Filter[] = [];
  ordering: Ordering = { field: "", orderType: OrderType.Asc };
  checked: number[] = [];
  selectedAll: boolean = false;

  @Prop() tableHeaders!: TableHeader[];
  @Prop() selectErase!: boolean;
  @Prop() selectMove!: boolean;
  @Prop() results!: any[];
  @Prop() total!: number;
  @Prop() totalCount!: number;
  @Prop() pageSize!: number;
  @Prop() searchable!: boolean;
  @Prop() editable!: boolean;
  @Prop() toggle!: boolean;
  @Prop() loading!: boolean;
  @Prop() selectAll!: number[];
  @Prop() singleCheck!: boolean;
  @Prop() tableClass!: string;
  @Prop() showRecipeIcon!: boolean;
  @Prop() showChangeLogIcon!: boolean;
  localizationState: any;

  @Watch("selectAll")
  onSelectAllChanged(val: number[]) {
    this.checked = val;
  }

  checkboxChanged(itemId: any, event: any) {
    if (event.target != null) {
      if (this.singleCheck) {
        this.checked = [];
        if (event.target.checked) {
          this.checked.push(itemId);
        }
      }
    }
  }

  changePage(page: number) {
    this.page = page;
    this.$emit("changePage", [
      page,
      this.pageSize,
      this.filters,
      this.ordering,
    ]);
  }

  get orderTypeAsc() {
    return this.ordering.orderType === OrderType.Asc;
  }

  get fromResult() {
    if (this.total > 0) return this.pageSize * this.page - this.pageSize + 1;
    else return 0;
  }

  get toResult() {
    const to = this.pageSize * this.page;
    if (to > this.totalCount) {
      return this.totalCount;
    }
    return to;
  }

  get range() {
    let range = 0;
    if (this.results.length > 0)
      range = Object.keys(this.results[0]).length - 1;
    return range;
  }

  get isRemoveDisabled() {
    return this.checked.length === 0;
  }

  get isMoveDisabled() {
    return this.checked.length === 0;
  }

  toggleOrdering(name: string) {
    this.ordering.field = name;

    if (this.ordering.orderType === OrderType.Asc) {
      this.ordering.orderType = OrderType.Desc;
    }
    else {
      this.ordering.orderType = OrderType.Asc;
    }

    this.filters = [];
    this.tableHeaders.map((header: any) => {
      if (header.searchString !== "")
        this.filters.push({ name: header.key, value: header.searchString });
    });

    this.$emit("order", this.filters, this.ordering);
  }

  search() {
    this.filters = [];
    this.tableHeaders.map((header: any) => {
      if (header.searchString !== "")
        this.filters.push({ name: header.key, value: header.searchString });
    });

    this.$emit("search", this.filters, this.ordering);
    this.page = 1;
  }

  toggleSwitch(value: boolean, id: number) {
    this.$emit("toggleSwitch", { value: value, id: id });
  }

  remove() {
    if (this.singleCheck) {
      this.$emit("remove", this.checked.length > 0 ? this.checked[0] : null);
    }
    else {
      this.$emit("remove", this.checked);
    }
    this.checked = [];
    this.checked.length = 0;
  }

  move() {
    this.$emit("move", this.checked);
    this.checked = [];
    this.checked.length = 0;
  }

  edit(id: number) {
    this.$emit("edit", id);
    this.tableHeaders.map((header: any) => {
      header.searchString = "";
    });
  }

  clicked(id: number) {
    this.$emit("clicked", id);
  }
  selectAllChackboxes() {
    this.selectedAll = !this.selectedAll;
    this.$emit("selectAll", this.selectedAll);
  }

  onRecipeClick(id: number) {
    this.$emit("onRecipeClick", id);
  }

  onChangeLogClick(id: number) {
    this.$emit("onChangeLogClick", id);
  }

  get translations() {
    return this.localizationState.translations;
  }
}
